export default __webpack_public_path__ + "static/media/upOxxo.b19b3e1b.svg";